export default "__VITE_ASSET__7nHKdDD0__"